var map = {
	"./image-blue.svg": "WiW6",
	"./image-green.svg": "2w8Y",
	"./image-inbound.svg": "GGCO",
	"./image-inbound0.svg": "N88Z",
	"./image-orange.svg": "HYl1",
	"./image-outbound.svg": "cULC",
	"./image-red.svg": "mfg8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zRti";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/image\-.*\.svg$
// module id = zRti
// module chunks = 0 1